import type { FC, ReactElement, ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

import './index.scss'

export const DataPoints: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className,
}) => <div className={twMerge('data-points', className)}>{children}</div>

export const DataPoint: FC<{
  header?: ReactElement | string
  value?: string | ReactElement
  values?: string[] | ReactElement[]
  className?: string
}> = ({ header = '', value = '', values = [], className = '' }) => (
  <div className={`data-point ${className}`}>
    {header && <h4>{header}</h4>}

    {[value, ...values].map((value, idx) => (
      <div className="data-point__value" key={idx}>
        {value}
      </div>
    ))}
  </div>
)
